/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/link/custom-elements';

import { defineCustomElement as defineOsdsLink } from '@ovhcloud/ods-stencil/components/link/custom-elements/osds-link.js';

export const OsdsLink = /*@__PURE__*/createReactComponent<JSX.OsdsLink, HTMLOsdsLinkElement>('osds-link', undefined, undefined, defineOsdsLink);
